"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEB_FONTS = exports.SYSTEM_FONTS = void 0;
const WEB_FONTS = exports.WEB_FONTS = 'Web Fonts';
const SYSTEM_FONTS = exports.SYSTEM_FONTS = 'System Fonts';